(function(angular) {
    'use strict';

    var inject = ['$scope', '$stateParams', '$sce', 'fileManager', 'dmsToolbarButtonDepot', 'dmsGridSelection', '$state', 'dmsItemRouter', 'dmsIconService', '$timeout', '$translate', '$window', 'dmsFolderService', 'getDocument'];

    var folderFileView = function($scope:any, $stateParams:any, $sce:any, fileManager:any, dmsToolbarButtonDepot:any, dmsGridSelection:any, $state:any, dmsItemRouter:any, dmsIconService:any, $timeout:any, $translate:any, $window:any, dmsFolderService:any, getDocument:any) {

        // We're going to 'select' a single item for the toolbar to operate on
        var selection = dmsGridSelection.get('documentView');
        selection.clear();

        var depot = dmsToolbarButtonDepot;
        var downloadButton = depot.get('download');
        var downloadAsPDF = depot.get('downloadPDF');
        downloadAsPDF.isVisible = false;

        var manageButton = depot.get('manageDocs')
            .addChild(depot.get('send'))
            .addChild(depot.get('move'))
            .addChild(depot.get('copy'))
            .addChild(depot.get('rename'))
            .addChild(depot.get('remove'))
            .addChild(depot.get('insertScan'))
            .addChild(depot.get('addPreviewComment'))
            .addChild(depot.get('deleteLock'));

        $scope.buttons = [
            depot.get('openLocally'),
            downloadButton,
            downloadAsPDF,
            manageButton
        ];

        function getContainer(folderId:any, projectId:any, templateId:any) {
            var type = folderId ? 'Folder' : 'Project';
            var id = folderId || templateId || projectId;

            return {
                itemType: type,
                id: id
            };
        }

        $scope.container = getContainer($stateParams.folderId, $stateParams.projectId, $stateParams.templateId);

        $scope.canViewDocument = getDocument ? getDocument : false;

        dmsFolderService.getRoot($scope.container).then(function(root:any) {
            if (root.primaryAssociationId && root.primaryAssociationType === 'Client') {
                $scope.clientId = root.primaryAssociationId;
                manageButton.addChild(depot.get('approve'));
            }
        });

        function updateDownloadIcon(fileExtension:any) {
            var newDownloadButton = depot.get('download');
            newDownloadButton.icon = dmsIconService.getIcon(fileExtension);
            // We have to replace it with a new entity to trigger the update
            $scope.buttons[1] = newDownloadButton;
        }

        function loadItem() {
            var promise = fileManager.getDocumentInfo($scope.container.itemType, $scope.container.id, $stateParams.fileId, true, true);
            return promise.then(function(result:any) {
                var file = result.data;
                $scope.file = [file];
                $scope.lock = file.lock;
                $scope.fileName = file.name;
                $scope.downloadUrl = $sce.trustAsResourceUrl(file.downloadUrl);
                $scope.previewMimeType = (file.isViewable) ? 'application/pdf' : file.mimeType;
                $scope.mimeType = file.mimeType;
                $scope.fileId = file.id;
                $scope.itemType = file.itemType;
                $scope.lockToolTip = '';

                if(file.lock){
                    if(file.lock.level.toLowerCase() === 'master') {
                        var lockVariables = {
                            lockerName: file.lock.createdBy,
                            lockedDate: $window.moment(file.lock.createdDate).format('LL')
                        };
                        $scope.lockToolTip = $translate.instant('Bluemoon.DMS.Common.LockedMaster', lockVariables);
                    } else {
                        $scope.lockToolTip = $translate.instant('Bluemoon.DMS.Common.LockedSubordinate');
                    }
                }

                var fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();

                downloadAsPDF.isVisible = (fileExtension !== 'pdf');

                updateDownloadIcon(fileExtension);

                selection.clear();
                // Avoids some race conditions regarding enabling buttons
                $timeout(function() {
                    selection.setSelected(file);
                });

                // FIXME: Remove HTML manipulation from controller.
                // This should only be done by CSS (preferably) or a directive
                var previewDiv = document.getElementsByClassName('bento-splitter-group-main-inner has-right-pane');
                if (previewDiv.length) {
                    (previewDiv[0] as any).style.overflow = 'hidden';
                }

                dmsFolderService.getRoot($scope.container).then(function(ancestor:any) {
                    if(ancestor.rootType) {
                        $scope.container.rootType = ancestor.rootType;
                    } else if (ancestor.primaryAssociationName && ancestor.primaryAssociationType === 'Client') {
                        $scope.container.primaryAssociationName = ancestor.primaryAssociationName;
                    }
                    $scope.container.item = file;
                    //to inform main-controller.js to update page title when the file preview page is loaded
                    $timeout(function() {
                        $scope.$emit('pageTitleUpdate', $scope.container);
                    });

                });
            });
        }

        $scope.$on('dmsItemRenamed', loadItem);

        $scope.$on('dms-lock-deleted', loadItem);

        $scope.$on('dms-opened-locally', function() {
            $scope.lock = true;
            setTimeout(function() {
                loadItem();
            }, 15000);
        });

        $scope.$on('dms-operation-complete', function(event:any, operationModel:any) {
            var operation = operationModel.type;
            var data = operationModel.operationData;
            var target;

            if (operation === 'move') {
                target = dmsItemRouter.getTargetStateFromParent(data.sourceItem, data.destination);
            } else if (operation === 'delete' || operation === 'moveToRecycle') {
                target = dmsItemRouter.getTargetStateFromStateParams($scope.container, $stateParams);
            }

            if (target) {
                $state.go(target.state, target.params);
            }
        });

        loadItem();
    };

    folderFileView.$inject = inject;

    angular.module('onvio.documents').controller('folderFileView', folderFileView);
})((window as any).angular);
